import styled, { css } from 'styled-components';

export const Container = styled.div<{
  abaAtiva: boolean;
  isFirst: boolean;
  isLast: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  width: 100%;
  min-height: 44px;
  position: relative;
  padding: 0.5rem 0.25rem;
  box-sizing: border-box;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 8px;
    right: 8px;
    height: 2px;
    background-color: ${({ theme, abaAtiva }) =>
      abaAtiva ? theme.colors.primaryRed400 : 'transparent'};
    transition: background-color 0.2s ease;

    ${({ isFirst }) =>
      isFirst &&
      css`
        border-bottom-left-radius: 12px;
      `}

    ${({ isLast }) =>
      isLast &&
      css`
        border-bottom-right-radius: 12px;
      `}
  }

  span.label {
    font-size: 14px;
    font-weight: 400;
    color: ${({ theme, abaAtiva }) => abaAtiva ? theme.colors.primaryRed400 : theme.colors.primaryGray400};
    text-align: center;
    line-height: 1.2;
    flex-shrink: 1;
    min-width: 0;
    margin: 0;
  }

  span.contador {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 27px;
    width: auto;
    line-height: 18px;
    padding: 4px 6px;
    font-size: 11px;
    font-weight: 600;
    background-color: ${({ theme, abaAtiva }) => abaAtiva ? theme.colors.primaryRed400 : 'var(--count-badge-bg)'};
    color: ${(props: any) => props.theme.colors.pureWhite};
    border-radius: 4px;
    text-align: center;
    flex-shrink: 0;
  }

  @media (max-width: 1200px) {
    gap: 0.2rem;
    padding: 0.4rem 0.2rem;
    min-height: 40px;

    span.label {
      font-size: 12px;
    }

    span.contador {
      min-width: 27px;
      width: auto;
      line-height: 18px;
      padding: 4px 6px;
      font-size: 11px;
    }
  }

  @media (max-width: 768px) {
    gap: 0.25rem;
    padding: 0.5rem 0.25rem;
    min-height: 44px;

    span.label {
      font-size: 13px;
    }

    span.contador {
      min-width: 27px;
      width: auto;
      line-height: 18px;
      padding: 4px 6px;
      font-size: 11px;
    }

    &::after {
      left: 6px;
      right: 6px;
    }
  }

  &:hover {
    span.label {
      color: ${({ theme }) => theme.colors.primaryRed400};
      transition: all 0.2s ease;
    }

    background-color: ${(props: any) => props.theme.colors.cf8f9fa};
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  transition: all 0.2s ease;
`;

export const Tooltip = styled.div`
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  background: ${({ theme }) => theme.colors.interfaceGray700};
  color: ${({ theme }) => theme.colors.interfacePure0};
  font-size: 12px;
  font-weight: 600;
  padding: 6px 10px;
  border-radius: 8px;
  white-space: nowrap;
  box-shadow: 0 4px 12px rgba(0,0,0,0.18);
  z-index: 20;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 6px;
    border-style: solid;
    border-color: ${({ theme }) => theme.colors.interfaceGray700} transparent transparent transparent;
  }
`;